
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 53 53","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon-fill arrow",attrs:{"fill":"#5ebca8","d":"M42.112 9.76l1.77 1.77-7.84 7.83-5.33-5.33 1.76-1.77 3.57 3.57z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M36.862 27.55a13.24 13.24 0 01-13.2-13.23h2.5a10.71 10.71 0 101.7-5.87l-.37.57h-6.63v-2.5h5.36a13.23 13.23 0 1110.64 21.03zM12.482 13.48a6.2 6.2 0 116.19-6.19 6.2 6.2 0 01-6.19 6.19zm0-9.89a3.7 3.7 0 103.69 3.7 3.7 3.7 0 00-3.69-3.7z"}}),_c('path',{staticClass:"icon-fill",attrs:{"fill":"#5ebca8","d":"M18.862 51.92h-2.5V34.41l3.24-3.25v-11.5a2.54 2.54 0 00-1.49-2.31l-5.63-2.51-5.62 2.51a2.55 2.55 0 00-1.5 2.31v11.5l3.25 3.25v17.51h-2.5V35.44l-3.25-3.24V19.66a5 5 0 013-4.57l6.65-3 6.64 3a5 5 0 013 4.59V32.2l-3.29 3.24z"}})])
          )
        }
      }
    